import type { AxiosRequestConfig } from "axios";
import type { CohesiveAPIClient } from "../../client";
import type {
  AdminInviteUserPayload,
  AdminUpdateUserOnboardingPayload,
  AdminUser,
  ListUsersResponse,
  UpdateUserOnboardingResponse,
} from "./types";

export * from "./types";

const ENDPOINTS = {
  LIST_USERS: "/api/v2/admin/organizations/:organization_id/users",
  INVITE_USER: "/api/v2/admin/organizations/:organization_id/invite-user",
  UPDATE_ONBOARDING:
    "/api/v2/admin/organizations/:organization_id/users/:user_id/onboarding",
};

export class AdminUsersAPI {
  constructor(private client: CohesiveAPIClient) {}

  async listOrganizationUsers(
    organizationId: string,
    config?: AxiosRequestConfig,
  ): Promise<AdminUser[]> {
    const url = ENDPOINTS.LIST_USERS.replace(
      ":organization_id",
      organizationId,
    );
    const response = await this.client.axios.get<ListUsersResponse>(
      url,
      config,
    );
    return response.data.data.users;
  }

  async inviteUser(
    organizationId: string,
    payload: AdminInviteUserPayload,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const url = ENDPOINTS.INVITE_USER.replace(
      ":organization_id",
      organizationId,
    );
    await this.client.axios.post(url, payload, config);
  }

  async updateUserOnboarding(
    organizationId: string,
    userId: string,
    payload: AdminUpdateUserOnboardingPayload,
    config?: AxiosRequestConfig,
  ): Promise<UpdateUserOnboardingResponse["data"]> {
    const url = ENDPOINTS.UPDATE_ONBOARDING.replace(
      ":organization_id",
      organizationId,
    ).replace(":user_id", userId);
    const response = await this.client.axios.put<UpdateUserOnboardingResponse>(
      url,
      payload,
      config,
    );
    return response.data.data;
  }
}
